










import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from './Icon.vue'

@Component({
  props: {
    errors: {
      type: Array,
      default: []
    },
    html: { // sanitized text only
      type: Boolean,
      default: false
    }
  },
  components: {
    Icon
  }
})
export default class ErrorMessages extends Vue {
}
